var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-self-selection"},[_c('question',{attrs:{"question":_vm.opts.question,"answers":_vm.opts.answers},on:{"resolve":_vm.resolve,"desolve":_vm.desolve}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }